/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import { spacing } from '$variables/theme';

export const ErrorMessage = styled.div`
  width: 302px;
  line-height: 24px;
  text-align: center;

  margin-bottom: ${spacing.medium};
`;

export const Centered = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  margin-top: ${spacing.xxxGiant};
`;
